export const getStickyStyle = (left: number, minWidth: number, isHeader = false) => ({
  position: "sticky",
  ...(isHeader ? { top: 0 } : {}),
  left,
  minWidth,
  backgroundColor: isHeader ? "#92d050" : "#f5f5f5",
  zIndex: isHeader ? 3 : 1,
  borderRight: "1px solid #e0e0e0",
  boxSizing: "border-box",
});
